import { StyledFormErrors } from './style';

const FormErrors = ({ errors }) => {
  if(errors.length){
    window.scrollTo(0, 0);

    return(
      <StyledFormErrors>
        <div className="title">
          Corrija os erros abaixo para continuar:
        </div>

        <ul>
          {errors.map((error, i) => {
            return <li key={i}>{error}</li>
          })}
        </ul>
      </StyledFormErrors>
    )
  }
  else return null;
}

export default FormErrors;
